import type { StartFailure } from './parseStartError'
import { translationFailureText } from './translationFailureText'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

/**
 * Честный фолбэк ИМЕННО этой ручки. `failureText` (словарь СТАРТОВ прогонов)
 * на неразобранном коде заголовком говорит «Не удалось запустить прогон» —
 * но `PUT /translations/{lang}` никакой прогон не запускает, и такой
 * заголовок соврал бы автору про суть происходящего.
 */
const fallback = (): string => messagesNow(messages).publishLanguageFailed

/**
 * Текст отказа `setTranslationPublished` (§3.6/§7.6). Сам разбор ответа в
 * `StartFailure` НЕ дублируется — вызывающий передаёт результат
 * `parseStartError` (структура `detail` у этой ручки та же, что и у стартов
 * прогонов). Здесь только интерпретация: оба бизнес-кода ручки
 * (`unsupported_language`, `translation_storage_limit`) уже разобраны
 * `translationFailureText`, им и отдаём приоритет. На всё остальное —
 * незнакомый бизнес-код, сеть, `500` — фолбэк по сути ЭТОЙ ручки, а не общий
 * словарь стартов прогона.
 */
export const translationPublishFailureText = (failure: StartFailure): string =>
  failure.kind === 'business'
    ? (translationFailureText(failure.code, failure.message) ?? fallback())
    : fallback()
